import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  API_ADD_CHANGE_INFORMATION_CARD,
  API_CHECK_ENGINES_MODIF,
  API_CHECK_ENGINES_STATIC_MODIF,
  API_DOWNLOAD_FILE_BOAT_CARD_MODIF,
  API_GET_BILL,
  API_GET_BOAT_CARD_FOR_MODIF,
  API_GET_INFO_BY_PERS_NUM,
  API_GET_INFO_BY_UNP,
  API_GET_QR,
  API_TAKE_OFF_BOAT_CARD_MODIF,
  MAIN_URL,
  PORT,
  PORT_FOR_INTEGRATION,
} from "../../constants/constants";

import {
  ERROR_INFO_BY_PERSONAL_NUM,
  GET_INFO_BY_PERSONAL_NUM,
  GET_INFO_BY_PERSONAL_NUM_AGENT,
  LOADING_INFO_BY_PERSONAL_NUM,
  SET_INTERESTED_USER_DATA,
  SIGN_STRING_ERROR,
} from "../types";

const setUserInfoByPersonalNum = (data) => ({
  type: GET_INFO_BY_PERSONAL_NUM,
  payload: data,
});

const setAgentInfoByPersonalNum = (data) => ({
  type: GET_INFO_BY_PERSONAL_NUM_AGENT,
  payload: data,
});

const loadingUserInfoByPersonalNum = () => ({
  type: LOADING_INFO_BY_PERSONAL_NUM,
});

const errorUserInfoByPersonalNum = (data) => ({
  type: ERROR_INFO_BY_PERSONAL_NUM,
  payload: data,
});

export const sendSignStringError = (data) => ({
  type: SIGN_STRING_ERROR,
  payload: data,
});

const setInterestedUserData = (data) => ({
  type: SET_INTERESTED_USER_DATA,
  payload: data,
});

const saveApplicationRequest = () => ({
  type: SAVE_APPLICATION_REQUEST,
});

const saveApplicationSuccess = (responseText) => ({
  type: SAVE_APPLICATION_SUCCESS,
  payload: responseText,
});

const saveApplicationFailure = () => ({
  type: SAVE_APPLICATION_FAILURE,
});

const getDataByUnpSuccess = (response) => ({
  type: GET_DATA_BU_UNP_SUCCESS,
  payload: response,
});

const getDataByUnpFailure = () => ({
  type: GET_DATA_BU_UNP_FAILURE,
});

export const CREATE_BILL_REQUEST = "CREATE_BILL_REQUEST";
export const CREATE_BILL_SUCCESS = "CREATE_BILL_SUCCESS";
export const CREATE_BILL_FAILURE = "CREATE_BILL_FAILURE";

export const FETCH_QR_REQUEST = "FETCH_QR_REQUEST";
export const FETCH_QR_SUCCESS = "FETCH_QR_SUCCESS";
export const FETCH_QR_FAILURE = "FETCH_QR_FAILURE";

export const SAVE_APPLICATION_REQUEST = "SAVE_APPLICATION_REQUEST";
export const SAVE_APPLICATION_SUCCESS = "SAVE_APPLICATION_SUCCESS";
export const SAVE_APPLICATION_FAILURE = "SAVE_APPLICATION_FAILURE";

// export const CHECK_APPLICATION_REQUEST = "CHECK_APPLICATION_REQUEST";
// export const CHECK_APPLICATION_SUCCESS = "CHECK_APPLICATION_SUCCESS";
// export const CHECK_APPLICATION_FAILURE = "CHECK_APPLICATION_FAILURE";

export const DEREGISTER_ENGINE_REQUEST = "DEREGISTER_ENGINE_REQUEST";
export const DEREGISTER_ENGINE_SUCCESS = "DEREGISTER_ENGINE_SUCCESS";
export const DEREGISTER_ENGINE_FAILURE = "DEREGISTER_ENGINE_FAILURE";
export const DEREGISTER_RESET_STATUS_ERROR = "DEREGISTER_RESET_STATUS_ERROR";

export const GET_DATA_BU_UNP_REQUEST = "GET_DATA_BU_UNP_REQUEST";
export const GET_DATA_BU_UNP_SUCCESS = "GET_DATA_BU_UNP_SUCCESS";
export const GET_DATA_BU_UNP_FAILURE = "GET_DATA_BU_UNP_FAILURE";

export const CHECK_ENGINE_VIN_REQUEST = "CHECK_ENGINE_VIN_REQUEST";
export const CHECK_ENGINE_VIN_OK = "CHECK_ENGINE_VIN_OK";
export const CHECK_ENGINE_VIN_SUCCESS = "CHECK_ENGINE_VIN_SUCCESS";
export const CHECK_ENGINE_VIN_FAILURE = "CHECK_ENGINE_VIN_FAILURE";

export const CHECK_ENGINE_STATIC_VIN_REQUEST =
  "CHECK_ENGINE_STATIC_VIN_REQUEST";
export const CHECK_ENGINE_STATIC_VIN_OK = "CHECK_ENGINE_STATIC_VIN_OK";
export const CHECK_ENGINE_STATIC_VIN_SUCCESS =
  "CHECK_ENGINE_STATIC_VIN_SUCCESS";
export const CHECK_ENGINE_STATIC_VIN_FAILURE =
  "CHECK_ENGINE_STATIC_VIN_FAILURE";

export function interestedUserData(id) {
  return async (dispatch) => {
    const responseBoatCard = await fetchWithToken(
      MAIN_URL + PORT + API_GET_BOAT_CARD_FOR_MODIF + String(id),
    );

    let dataBoatCard = await responseBoatCard.json();
    dataBoatCard.stranId = "Республика Беларусь";
    dataBoatCard.agentCountry = "Республика Беларусь";
    dataBoatCard.docType = { value: dataBoatCard.docType };
    dataBoatCard.gorodId = {
      value: dataBoatCard.gorodId,
      label: dataBoatCard.gorodIdName,
    };
    dataBoatCard.oblId = {
      value: dataBoatCard.oblId,
      label: dataBoatCard.oblIdName,
    };
    dataBoatCard.rayonId = {
      value: dataBoatCard.rayonId,
      label: dataBoatCard.rayonIdName,
    };
    dataBoatCard.boatType = { value: dataBoatCard.boatType };
    dataBoatCard.boatVid = { value: dataBoatCard.boatVid };
    dataBoatCard.bodyMaterial = { value: dataBoatCard.bodyMaterial };
    dataBoatCard.saCategory = { value: dataBoatCard.saCategory };

    dataBoatCard.enginesList = dataBoatCard.enginesList.map((item) => ({
      ...item,
      isNew: false,
      isTakeOff: false,
      id: item.engid,
    }));

    dataBoatCard.engineStaticList = dataBoatCard.engineStaticList.map(
      (item) => ({
        ...item,
        isEditable: false,
        isNew: false,
        id: item.engstatid,
      }),
    );

    dataBoatCard.boatCardSpecmarksList = dataBoatCard.boatCardSpecmarksList.map(
      (item, index) => ({
        ...item,
        id: index + 1,
        msmDate: item.msmDate.split("-").reverse().join("."),
      }),
    );

    dataBoatCard.boatArrestsList = dataBoatCard.boatArrestsList.flatMap(
      (item) => {
        const onObject = {
          ...item,
          dateText: item.onDate,
          isActiveText: item.isActiveOn,
          orgText: item.onOrg,
          officerText: item.onOfficer,
          nameNumDateOfDocText: item.nameNumDateOfDocON,
          noteText: item.onNote,
        };
        const offObject = item.offDate
          ? {
              ...item,
              id: item.id * 2,
              dateText: item.offDate,
              isActiveText: item.isActiveOff,
              orgText: item.offOrg,
              officerText: item.offOfficer,
              nameNumDateOfDocText: item.nameNumDateOfDocOFF,
              noteText: item.offNote,
            }
          : null;

        return offObject ? [onObject, offObject] : [onObject];
      },
    );

    dispatch(setInterestedUserData(dataBoatCard));
  };
}

export const sendPersonalNum = (personalNum, password, agenNumber, userId) => {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL + PORT_FOR_INTEGRATION + API_GET_INFO_BY_PERS_NUM + personalNum,
    ).catch((err) => console.log(err));

    if (request.ok) {
      const data = await request.json();
      dispatch(sendSignString(data, personalNum, password, agenNumber, userId));
    }
  };
};

export const sendUnp = (unp) => {
  return async (dispatch) => {
    dispatch({ type: GET_DATA_BU_UNP_REQUEST });
    try {
      const response = await fetchWithToken(
        MAIN_URL + PORT_FOR_INTEGRATION + API_GET_INFO_BY_UNP + unp,
      ).catch((err) => console.log(err));

      if (response.status !== 200) {
        dispatch(getDataByUnpFailure());
      } else {
        const data = await response.json();

        data.oblId = { value: data.oblId };
        data.gorodId = { value: data.gorodId };
        data.rayonId = { value: data.rayonId };

        dispatch(getDataByUnpSuccess(data));
      }
    } catch (error) {
      dispatch(getDataByUnpFailure());
    }
  };
};

export const sendSignString = (
  value,
  personalNum,
  password,
  agenNumber,
  userId,
) => {
  return async (dispatch) => {
    const request = await fetch("http://localhost:8085/sign-string", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...value, pw: password }),
    });

    if (request.ok) {
      const data = await request.json();
      dispatch(getUserInfoByPersonalNum(data, personalNum, agenNumber, userId));
    } else {
      const errorText = await request.text();
      if (errorText === "Invalid container password") {
        dispatch(sendSignStringError(`Ошибка подписи! Неверный пароль.`));
      } else {
        dispatch(
          getUserInfoByPersonalNumError(personalNum, agenNumber, userId),
        );
      }
    }
  };
};

export const getUserInfoByPersonalNum = (
  value,
  personalNum,
  agenNumber,
  userId,
) => {
  return async (dispatch) => {
    dispatch(loadingUserInfoByPersonalNum());
    const request = await fetchWithToken(
      MAIN_URL +
        PORT_FOR_INTEGRATION +
        API_GET_INFO_BY_PERS_NUM +
        `${userId}/${personalNum}?agent=${agenNumber}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(value),
      },
    );

    if (request.ok) {
      const data = await request.json();

      if (agenNumber === 1) {
        data.stranId = "Республика Беларусь";
        data.docType = { value: data.docType };
        data.gorodId = { value: data.gorodId, label: data.gorodIdName };
        data.oblId = { value: data.oblId, label: data.oblIdName };
        data.rayonId = { value: data.rayonId, label: data.rayonIdName };
        dispatch(setUserInfoByPersonalNum(data));
      }
      if (agenNumber === 2) {
        data.agentCountry = "Республика Беларусь";
        data.agentDocType = { value: data.agentDocType };
        data.agentGorodId = { value: data.agentGorodId };
        data.agentOblId = { value: data.agentOblId };
        data.agentRayonId = { value: data.agentRayonId };
        dispatch(setAgentInfoByPersonalNum(data));
      }
    } else {
      const errorText = await request.json();
      dispatch(
        errorUserInfoByPersonalNum(
          errorText?.message || "Ошибка загрузки данных",
        ),
      );
    }
  };
};

export const getUserInfoByPersonalNumError = (
  personalNum,
  agenNumber,
  userId,
) => {
  return async (dispatch) => {
    dispatch(loadingUserInfoByPersonalNum());

    const request = await fetchWithToken(
      MAIN_URL +
        PORT_FOR_INTEGRATION +
        API_GET_INFO_BY_PERS_NUM +
        `${userId}/${personalNum}?agent=${agenNumber}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          headers: null,
          body: null,
          identificationNumber: personalNum,
          log: false,
        }),
      },
    );

    if (request.ok) {
      const data = await request.json();

      if (agenNumber === 1) {
        data.stranId = "Республика Беларусь";
        data.docType = { value: data.docType };
        data.gorodId = { value: data.gorodId, label: data.gorodIdName };
        data.oblId = { value: data.oblId, label: data.oblIdName };
        data.rayonId = { value: data.rayonId, label: data.rayonIdName };
        dispatch(setUserInfoByPersonalNum(data));
      }
      if (agenNumber === 2) {
        data.agentCountry = "Республика Беларусь";
        data.agentDocType = { value: data.agentDocType };
        data.agentGorodId = { value: data.agentGorodId };
        data.agentOblId = { value: data.agentOblId };
        data.agentRayonId = { value: data.agentRayonId };
        dispatch(setAgentInfoByPersonalNum(data));
      }
    } else {
      const errorText = await request.json();
      dispatch(
        errorUserInfoByPersonalNum(
          errorText?.message || "Ошибка загрузки данных",
        ),
      );
    }
  };
};

export const createBill = (billData) => async (dispatch) => {
  dispatch({ type: CREATE_BILL_REQUEST });
  try {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_INTEGRATION + API_GET_BILL,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(billData),
      },
    );

    const createdBill = await response.json();

    if (!createdBill.id) {
      dispatch({ type: CREATE_BILL_FAILURE, payload: createdBill.message });
    } else {
      dispatch({ type: CREATE_BILL_SUCCESS, payload: createdBill });
      dispatch(fetchQR(createdBill.serviceBillId));
    }
  } catch (error) {
    dispatch({ type: CREATE_BILL_FAILURE, payload: error.message });
  }
};

export const fetchQR = (serviceBillId) => async (dispatch) => {
  dispatch({ type: FETCH_QR_REQUEST });
  try {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_INTEGRATION + API_GET_QR,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({ serviceBillId }),
      },
    );
    const blob = await response.blob();
    const QRurl = URL.createObjectURL(blob);
    const onClose = false;

    dispatch({
      type: FETCH_QR_SUCCESS,
      payload: { id: serviceBillId, QRurl, onClose },
    });
  } catch (error) {
    dispatch({ type: FETCH_QR_FAILURE, payload: error.message });
  }
};

export const saveApplicationData = (idBoadCard, newData, file) => {
  return async (dispatch) => {
    dispatch(saveApplicationRequest());
    const formData = new FormData();
    if (file !== undefined) {
      formData.append("file", file);
    }
    formData.append("data", JSON.stringify(newData));

    try {
      const response = await fetchWithToken(
        MAIN_URL + PORT + API_ADD_CHANGE_INFORMATION_CARD + String(idBoadCard),
        {
          method: "POST",
          body: formData,
        },
      );

      if (response.status !== 200) {
        dispatch(saveApplicationFailure());
      } else {
        const responseText = await response.text();
        dispatch(saveApplicationSuccess(responseText));
      }
    } catch (error) {
      dispatch(saveApplicationFailure());
    }
  };
};

export const downloadReportBoatCardModif =
  (applicantId, bodyData) => async (dispatch) => {
    try {
      const response = await fetchWithToken(
        MAIN_URL + PORT + API_DOWNLOAD_FILE_BOAT_CARD_MODIF + applicantId,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bodyData),
        },
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const formData = await response.formData();
      const fileDocx = formData.get("docx");
      const fileUrl = URL.createObjectURL(fileDocx);
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileDocx.name;
      link.click();
      link.remove();
    } catch (error) {
      console.error("Failed to download report:", error);
    }
  };

export const deregisterEngine = (cardId, bodyData) => async (dispatch) => {
  dispatch({ type: DEREGISTER_ENGINE_REQUEST });

  try {
    const response = await fetchWithToken(
      MAIN_URL + PORT + `${API_TAKE_OFF_BOAT_CARD_MODIF}${cardId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      },
    );

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    dispatch({
      type: DEREGISTER_ENGINE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: DEREGISTER_ENGINE_FAILURE,
    });
  }
};

export const checkEngineVin = (bodyData) => async (dispatch) => {
  dispatch({ type: CHECK_ENGINE_VIN_REQUEST });

  try {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_CHECK_ENGINES_MODIF,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      },
    );

    if (response.status !== 200) {
      throw new Error("Ошибка соединения");
    }

    const data = await response.text();

    if (data === "OK") {
      dispatch({
        type: CHECK_ENGINE_VIN_OK,
      });
    } else {
      dispatch({
        type: CHECK_ENGINE_VIN_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: CHECK_ENGINE_VIN_FAILURE,
    });
  }
};

export const checkEngineStaticVin = (bodyData) => async (dispatch) => {
  dispatch({ type: CHECK_ENGINE_STATIC_VIN_REQUEST });

  try {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_CHECK_ENGINES_STATIC_MODIF,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      },
    );

    if (response.status !== 200) {
      throw new Error("Ошибка соединения");
    }

    const data = await response.text();

    if (data === "OK") {
      dispatch({
        type: CHECK_ENGINE_STATIC_VIN_OK,
      });
    } else {
      dispatch({
        type: CHECK_ENGINE_STATIC_VIN_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: CHECK_ENGINE_STATIC_VIN_FAILURE,
    });
  }
};
